module.exports = __webpack_public_path__ + "static/media/oryza_sativa.flower_parts.eef5a181.svg";